import {
  getNameDescriptionTableColumn,
  getBillBrandTableColumn,
  getStatusTableColumn,
  getProjectDomainTableColumn,
} from '@/utils/common/tableColumn'
import { numerify } from '@/filters'
import i18n from '@/locales'
// import setting from '@/config/setting'
import { currencyUnitMap } from '@/constants/currency'
import { accountsFilterByOem } from '@/utils/utils'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        field: 'name',
        hideField: true,
        edit: false,
        editDesc: false,
        addBackup: true,
        slotCallback: row => {
          row = accountsFilterByOem({ data: row, idKey: 'id', nameKey: 'name' })
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row, 'overview')}>{ row.name }</side-page-trigger>
          )
        },
        formatter: ({ row }) => {
          const changedRow = accountsFilterByOem({ data: row, idKey: 'id', nameKey: 'name' })
          return changedRow.name
        },
      }),
      getBillBrandTableColumn({ sortable: false, emptyValue: '-' }),
      getProjectDomainTableColumn(),
      getStatusTableColumn({ vm: this, statusModule: 'cloudaccount' }),
      // {
      //   field: 'amount',
      //   title: i18n.t('bill.text_141'),
      //   sortable: true,
      //   formatter: ({ row }) => {
      //     let sign = ''
      //     if (currencyUnitMap[this.currency]) {
      //       sign = currencyUnitMap[this.currency].sign || ''
      //     }
      //     return `${sign}${numerify(row.amount, '0,0.00')}`
      //   },
      // },
      // {
      //   field: 'year_amount',
      //   title: i18n.t('bill.text_139'),
      //   // sortable: true,
      //   formatter: ({ row }) => {
      //     let sign = ''
      //     if (currencyUnitMap[this.currency]) {
      //       sign = currencyUnitMap[this.currency].sign || ''
      //     }
      //     return `${sign}${numerify(row.year_amount, '0,0.00')}`
      //   },
      // },
      {
        field: 'currency',
        title: i18n.t('bill.currency_bill'),
      },
      {
        field: 'balance',
        title: i18n.t('bill.text_91'),
        formatter: ({ row }) => {
          if (!row.balance_available) {
            return '-'
          }
          let sign = ''
          if (currencyUnitMap[row.currency]) {
            sign = currencyUnitMap[row.currency].sign || ''
          }
          return `${sign} ${numerify(row.balance, '0,0.00')}`
        },
      },
    ]
  },
}
